/** Lowercase and strip accents so queries like "Tur" match "Türkiye". */
export function normalizeSearchText(value: string): string {
  return value
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .trim();
}

export function matchesSearchQuery(
  fields: Array<string | null | undefined>,
  query: string,
): boolean {
  const normalizedQuery = normalizeSearchText(query);
  if (!normalizedQuery) return true;
  return fields.some((field) =>
    normalizeSearchText(String(field ?? "")).includes(normalizedQuery),
  );
}

/**
 * Filter by a single display name. Starts-with hits come first; names that only
 * contain the query elsewhere follow. Empty / whitespace query returns `items`
 * unchanged (same reference) so callers can skip re-renders.
 */
export function filterByNameSearch<T>(
  items: T[],
  getName: (item: T) => string,
  query: string,
): T[] {
  const q = normalizeSearchText(query);
  if (!q) return items;

  const startsWith: T[] = [];
  const contains: T[] = [];
  for (const item of items) {
    const name = normalizeSearchText(getName(item));
    if (name.startsWith(q)) startsWith.push(item);
    else if (name.includes(q)) contains.push(item);
  }
  // One concat — avoids a comparator sort so contains can never outrank prefix.
  return startsWith.concat(contains);
}
